// src/services/ApiService.js

const getAuthHeaders = (accessToken) => {
  if (!accessToken) {
    throw new Error('No se encontró el token de acceso');
  }

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
};

const makeRequest = async (method, endpoint, accessToken = null, body = null) => {
  try {
    const headers = {};

    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    if (body) {
      headers['Content-Type'] = 'application/json';
    }

    const options = {
      method,
      headers,
    };

    if (body) {
      options.body = JSON.stringify(body);
    }
    const response = await fetch(endpoint, options);
    console.log(response);
    if (!response.ok) {
      throw new Error(`Error en ApiService: ${response}`);
    }

    return await response.json();
  } catch (error) {
    //console.error(`Error al hacer la solicitud (${method}):`, error);
    throw error;
  }
};

// Método GET (por ejemplo, obtener items)
//export const fetchItems = (endpoint, accessToken = null) => {
export const fetchItems = (endpoint, accessToken) => {
  return makeRequest('GET', endpoint, accessToken);
};

// Método POST (por ejemplo, agregar un item)
export const addItem = (endpoint, accessToken, itemData) => {
  return makeRequest('POST', endpoint, accessToken, itemData);
};

// Método PUT (por ejemplo, editar un item)
export const editItem = (endpoint, accessToken, itemData) => {
  return makeRequest('PUT', endpoint, accessToken, itemData);
};

// Método DELETE (por ejemplo, eliminar un item)
export const deleteItem = (endpoint, accessToken) => {
  return makeRequest('DELETE', endpoint, accessToken);
};
